import { useState } from 'react'
import { Box, Button, Chip, Grid, Tooltip } from '@mui/material'
import { Typography } from '../../../components'
import { useOrderBoardguardUpdates } from '../../../context/notifications'
import { BoardguardTicket, getNoShowTooltip, NoShowFields, pickNoShowFields, setOrderNoShow } from '../../../utils/boardguard'

export const NoShowRow = ({ orderId, fields: initialFields, ticket }: {
    orderId: number
    fields: NoShowFields
    ticket?: BoardguardTicket | null
}) => {
    const [fields, setFields] = useState(() => pickNoShowFields(initialFields))
    const [sourceFields, setSourceFields] = useState(initialFields)
    const [busy, setBusy] = useState(false)

    if (sourceFields !== initialFields) {
        setSourceFields(initialFields)
        setFields(pickNoShowFields(initialFields))
    }

    useOrderBoardguardUpdates((event) => {
        if (event.order_id === orderId) setFields(pickNoShowFields(event))
    })

    const toggle = async () => {
        setBusy(true)
        try {
            const updated = await setOrderNoShow(orderId, !fields.no_show)
            if (updated) setFields(pickNoShowFields(updated))
        } finally {
            setBusy(false)
        }
    }

    return (
        <Grid item xs={12}>
            <Grid container alignItems="center">
                <Grid item xs={6}>
                    <Typography fontWeight="bold">No-show:</Typography>
                </Grid>
                <Grid item xs={6}>
                    <Box sx={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center', gap: 1 }}>
                        {fields.no_show && (
                            <Tooltip title={getNoShowTooltip(fields, ticket)}>
                                <Chip color="error" label="No-show" />
                            </Tooltip>
                        )}
                        <Button size="small" variant="outlined" disabled={busy} onClick={toggle}>
                            {fields.no_show ? 'Desmarcar' : 'Marcar'}
                        </Button>
                    </Box>
                </Grid>
            </Grid>
        </Grid>
    )
}
